module.exports = __webpack_public_path__ + "img/deliver-img-2-2.56ece134.png";